<template>
  <div>
    <keep-alive>
      <component :is="enter" :changes="changes"></component>
    </keep-alive>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: 0,
    };
  },
  components: {
    // 科室管理主页面
    departList: () => import("./components/departList.vue"),
    // 成员管理页面
    memberManages: () => import("./components/memberManages.vue"),
    departPage: () => import("./components/departPage.vue"),
  },
  computed: {
    enter() {
      switch (this.isActive) {
        case 0:
          return "departList";
        case 1:
          return "memberManages";
        case 2:
          return "departPage";
      }
      return "page";
    },
  },
  methods: {
    changes(index) {
      if (index == "0" && this.isActive == "1") {
        //这里代表新增返回
        this.$children[0].Buriedpoint({
          code: "Dept:departList:members",
          parent_code: "Dept:departList",
        });
      }
      this.isActive = index;
    },
  },
};
</script>